import React, { useEffect, useState } from 'react'
import SideBar from '../SideBar'
import styles from "../../../assets/css/admin/layout.module.css";
import axios from 'axios';
import { baseUrl } from '../../../baseUrl';
import { useParams } from 'react-router-dom';

const EditQuiz = () => {
    const [exams,setExams]=useState([])
    const [subjects,setSubjects]=useState([])
    const [exam,setExam]=useState("")
    const [subject,setSubject]=useState("")
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const today = new Date().toISOString().split("T")[0];
    const [totalQ,setTotalQ]=useState(0)
    const [totalMarks,setTotalMarks]=useState(0)
    const [correct,setCorrect]=useState(4)
    const [wrong,setWrong]=useState(-1)
    const [timeLimit, setTimeLimit] = useState("");
    const [part,setPart]=useState("")
    const [desc,setDesc]=useState("")
    const [message, setMessage] = useState("");
    const params=useParams()

    const data={exam,subject,startDate,endDate,totalQ,totalMarks,correct,wrong,timeLimit,part,desc}


    useEffect(()=>{
        axios.get(`${baseUrl}/quiz/get?id=${params.id}`)
        .then(res=>{
            setExam(res.data.examName)
            setSubject(res.data.subjectName)
            setStartDate(res.data.startDate)
            setEndDate(res.data.endDate)
            setTotalQ(res.data.totalQuestions)
            setTotalMarks(res.data.totalMarks)
            setCorrect(res.data.correct)
            setWrong(res.data.wrong)
            setTimeLimit(res.data.timeLimit)
            setPart(res.data.part)
            setDesc(res.data.description)
        })

      axios.get(`${baseUrl}/exam/all`)
      .then(res=>setExams(res.data))
      .catch(err=>console.log(err))

      axios.get(`${baseUrl}/subject/all`)
      .then(res=>setSubjects(res.data))
      .catch(err=>console.log(err))
    },[])


  const handleSubmit=()=>{
    axios.post(`${baseUrl}/quiz/update?id=${params.id}`,data)
    .then(res=>{
      if(res.data==="success"){
        setMessage("Quiz Updated successfully")
      }
      if(res.data==="error"){
        setMessage("Something went wrong")
      }
    })
    .catch(err=>console.log(err))
  }
  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        <div style={{ height: "30px" }}></div>
        <hr></hr>
        <div
          className="container"
          style={{ backgroundColor: "#F3F8FB", padding: "40px" }}
        >
          <div className="bg-white p-4">
            <h4>Edit Quiz</h4>
            <div className="row mb-3">
              <div className="col-6">
                <label htmlFor="examName" className="form-label">
                  Select Exam
                </label>
                <select value={exam} onChange={(e)=>setExam(e.target.value)} className="form-select" id="examName" aria-label="Default select example">
                  <option selected>Select exam</option>
                  {exams.map((e, i) => (
                    <option key={i} value={`${e.examName}`}>
                      {e.examName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-6">
                <label htmlFor="subjectName" className="form-label">
                  Subject:
                </label>
                <select value={subject} onChange={(e)=>setSubject(e.target.value)} className="form-select" id="subjectName" aria-label="Default select example">
                  <option selected>Select subject</option>
                  {subjects.map((e, i) => (
                    <option key={i} value={`${e.subjectName}`}>
                      {e.subjectName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <label htmlFor="startDate" className="form-label">
                  Start Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="startDate"
                  placeholder=""
                  onChange={(e) => setStartDate(e.target.value)}
                  value={startDate}
                  min={today}
                />
              </div>
              <div className="col-6">
                <label htmlFor="endDate" className="form-label">
                  End Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="endDate"
                  placeholder=""
                  onChange={(e) => setEndDate(e.target.value)}
                  value={endDate}
                  min={today}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <label htmlFor="totalQuestions" className="form-label">
                  Total Questions
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="totalQuestions"
                  placeholder="Enter total number of questions"
                  onChange={(e) => setTotalQ(e.target.value)}
                  value={totalQ}
                />
              </div>
              <div className="col-6">
                <label htmlFor="totalMarks" className="form-label">
                  Total Marks
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="totalMarks"
                  placeholder="Enter total marks"
                  onChange={(e) => setTotalMarks(e.target.value)}
                  value={totalMarks}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <label htmlFor="marksCorrect" className="form-label">
                  Marks for Correct Answer:
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="marksCorrect"
                  placeholder="+4"
                  onChange={(e) => setCorrect(e.target.value)}
                  value={correct}
                />
              </div>
              <div className="col-6">
                <label htmlFor="marksWrong" className="form-label">
                  Negative Marks for wrong Answer:
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="marksWrong"
                  placeholder="-1"
                  onChange={(e) => setWrong(e.target.value)}
                  value={wrong}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <label htmlFor="timeLimit" className="form-label">
                  Time Limit in seconds
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="timeLimit"
                  placeholder=""
                  onChange={(e) => setTimeLimit(e.target.value)}
                  value={timeLimit}
                />
              </div>
              <div className="col-6">
                <label htmlFor="part" className="form-label">
                  Part
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="part"
                  placeholder=""
                  onChange={(e) => setPart(e.target.value)}
                  value={part}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <label htmlFor="desc" className="form-label">
                  Description
                </label>
                <textarea
                onChange={(e)=>setDesc(e.target.value)}
                  className="form-control"
                  id="desc"
                  placeholder="Write description here"
                  value={desc}
                ></textarea>
              </div>
            </div>
            {message && (
              <div
                className="alert alert-warning alert-dismissible fade show mt-3"
                role="alert"
              >
                {message}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setMessage(false)}
                ></button>
              </div>
            )}
            <button onClick={handleSubmit} className="btn btn-primary mt-4">
              Update
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default EditQuiz
